import { useEffect, useState } from 'react';
import api from './api';

/**
 * Whether the signed-in person may see Academy. The server decides (ACADEMY_MODE,
 * see server/utils/academyFlag.js); this only asks, once per page load. Any failure
 * means "no", and a failure is not remembered, so a blip does not hide it for the session.
 */
let cached = { token: null, promise: null };

const fetchAcademyAccess = () => {
    let token = null;
    try { token = localStorage.getItem('token'); } catch { /* storage unavailable */ }
    if (!token) return Promise.resolve(false);

    if (cached.token !== token || !cached.promise) {
        const promise = api.get('/academy/access')
            .then(res => Boolean(res.data?.enabled))
            .catch(() => {
                if (cached.promise === promise) cached = { token: null, promise: null };
                return false;
            });
        cached = { token, promise };
    }
    return cached.promise;
};

/** `{ enabled, loaded }` - `loaded` is false until the server has answered. */
export const useAcademyAccess = () => {
    const [state, setState] = useState({ enabled: false, loaded: false });

    useEffect(() => {
        let alive = true;
        fetchAcademyAccess().then(enabled => {
            if (alive) setState({ enabled, loaded: true });
        });
        return () => { alive = false; };
    }, []);

    return state;
};
